export class ContentCatalogItem {

    type;

    heading = "";
    description = "";

    media = [];

    primary_image_hidden = false;

    constructor( type ) {
        this.type = type;
    }

    toJSON() {
        let { type, heading, description, media, primary_image_hidden } = this;

        if (!heading) heading = "";
        else heading = heading.trim();

        if (!description) description = "";
        else description = description.trim();

        if (!media) media = [];
        else media = media.filter( v => v.src )

        primary_image_hidden = !!primary_image_hidden;
        
        return { type, heading, description, media, primary_image_hidden };
    }
}

export class ContentCatalogClientOeuvreItem extends ContentCatalogItem {

    uid;

    constructor( client_oeuvre ) {

        super( "client_oeuvre" );

        this.uid = client_oeuvre.uid;
    }

    toJSON() {
        return {
            ...super.toJSON(),
            uid: this.uid
        };
    }

    static fromJSON( json ) {

        let item = new ContentCatalogClientOeuvreItem({
            uid: json.uid
        });

        item.heading                = json.heading;
        item.description            = json.description;
        item.media                  = json.media;
        item.primary_image_hidden   = !!json.primary_image_hidden;

        return item;
    }
}

export class ContentCatalog {

    title = "";

    items = []

    toJSON() {
        return {
            title: this.title,
            items: this.items.map( item => item.toJSON() )
        };
    }

    clone() {
        return ContentCatalog.fromJSON( this.toJSON() );
    }

    /**
     * @param {Oeuvre|Mesh} object
     * @returns ContentCatalogItem
     */
    solveItemByObject( object ) {

        if (!object) return null;

        for (let item of this.items) {

            switch (item.type) {
                case 'client_oeuvre':

                    if (object instanceof Oeuvre && item.uid == object.uid) {
                        return item;
                    } else if (object.mesh && object.mesh.userData && object.mesh.userData.type == 'oeuvre' && item.uid == object.mesh.userData.oeuvre_uid) {
                        return item;
                    }

                    break;
            }
        }   

        return null;
    }

    solveItemsByType( type ) {
        return this.items.filter( item => item.type == type );
    }

    getNextItemOf( item ) {
        let item_idx = this.items.indexOf( item );
        if (item_idx != -1) {
            return this.items[ item_idx + 1 ];
        }
    }

    getPrevItemOf( item ) {
        let item_idx = this.items.indexOf( item );
        if (item_idx != -1) {
            return this.items[ item_idx - 1 ];
        }
    }

    static fromJSON( json = {} ) {

        let catalog = new ContentCatalog();

        if (json.title) catalog.title = json.title;

        for (let item of json.items) {
            switch (item.type) {
                case "client_oeuvre":
                    catalog.items.push( ContentCatalogClientOeuvreItem.fromJSON( item ));
            }
        }

        return catalog;
    }

    static fromArrangement( arrangement ) {

        let catalog = new ContentCatalog();

        for (let uid in arrangement.oeuvres) {

            catalog.items.push( ContentCatalogClientOeuvreItem.fromJSON({ uid }));

        }

        return catalog;
    }
}